import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-access_denied',
  templateUrl: './access_denied.component.html',
  styleUrls: ['./access_denied.component.scss'],
})
export class AccessDeniedComponent implements OnInit {
  ngOnInit(): void {}
}
